import { checkMarkIcon } from "app/constants/IconsConstants";
import React from "react";

export interface ICheckboxProps {
	isActive: boolean | null;
	isDisabled?: boolean;
	name?: string;
	id?: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Checkbox = ({
	isActive, name, isDisabled, id, onChange
} : ICheckboxProps) => (
	<label className="input-checkbox">
		<input
			type="checkbox"
			name={name}
			id={id}
			disabled={isDisabled}
			checked={!!isActive}
			onChange={onChange}
		/>
		<div>{checkMarkIcon}</div>
	</label>
);